<template>
    <div class="footer-links">
        <div class="grid">
            <div class="col">
                <h1>IMPRINT §5 TMG</h1>
                <ul>
                    <li><span class="icon-home"/>wireplus GmbH</li>
                    <li><span class="icon-linkedin"/>Managing Director: Michael Offermanns</li>
                    <li><span class="icon-location"/>Geb. 3.09, Schanzenstraße 6-20, 51063 Köln</li>
                    <li><span class="icon-phone"/>+49 152 - 089 780 17</li>
                    <li><span class="icon-fax"/>+49 2408 - 59 84 919</li>
                    <li><span class="icon-mail"/><a href="mailto:info@wizypay.net">info@wizypay.net</a></li>
                    <li><span class="icon-info"/>HRB 98193, Amtsgericht Köln</li>
                </ul>
            </div>
            <div class="col">
                <h1>QUICK LINKS</h1>
                <ul>
                    <li>Support</li>
                    <li>About App</li>
                </ul>
            </div>
            <div class="col">
                <h1>QUOTE</h1>
                <p>
                    “It is not the strongest of the species that survives, nor the most intelligent that survives. It is the one that is the most adaptable to change." <br/><br/><span>~ Charles Darwin</span>
                </p>
            </div>
            <hr class="line"/>
            <div class="copyright">
                <span>© 2019 WIREPLUS GMBH. ALL RIGHTS RESERVED.</span>
                <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#facts">Facts</a></li>
                    <li><a href="#prev">Preview</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: "Footer",
  props: []
};
</script>

<style lang="scss" scoped>
.footer-links{
    @media(min-width: 780px){
        margin-top: 8%;
    }
    margin-top: 10%;
    .grid{
        margin: 0 auto;
        text-align: center;
    }
    .col{
        vertical-align: top;
        display: block;
        @media(min-width: 780px){
            display: inline-block;
            max-width: 25%;
            text-align: left;
            margin: 0 2.5% 0 2.5%;       
        }
        margin: 5% 2.5% 0 2.5%;
        .top{
            margin-top: 4%;
        }
        h1{
            font-weight: bold;
            font-size: 1rem;
            color: rgb(73,78,84);
            margin-bottom: 5%;
        }
        p{
            color: rgb(107,115,122);
            line-height: 1.5rem;
            span{
                font-style: italic;
            }
        }
        ul{
            li{
                color: rgb(107,115,122);
                line-height: 1.5rem;
                a{
                    text-decoration: none;
                    color: rgb(107,115,122);
                }
                span{
                    margin-right: 10px;
                    &.icon-mail{
                        font-size: 1.2rem;
                        vertical-align: middle;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
    .copyright{
        color: rgb(107,115,122);
        margin-bottom: 2%;
        font-size: 0.8rem;
        span{
            padding: 5%;
        }
        ul{
            display: inline-block;
            li{
                display: inline-block;
                font-weight: bold;
                a{
                    padding: 10%;
                    @media(min-width: 780px){
                        padding: 0 5% 0 5%;
                    }
                    text-decoration: none;
                    color: rgb(107,115,122);
                }
            }
        }
    }
    .line{
        margin-top: 2%;
        margin-bottom: 2%;
        border-top: 1px solid lightgrey;
        width: 50%;
    }
}
</style>
